module.exports = __webpack_public_path__ + "img/figma-brands.900b6b29.svg";